module.exports = __webpack_public_path__ + "static/bohater_7-c65fa48ac64495b5992d4d0a4c045c95.png";